import { render, staticRenderFns } from "./InnerIntegrationStatistics_new.vue?vue&type=template&id=703ffdd8&scoped=true"
import script from "./InnerIntegrationStatistics_new.vue?vue&type=script&lang=js"
export * from "./InnerIntegrationStatistics_new.vue?vue&type=script&lang=js"
import style0 from "./InnerIntegrationStatistics_new.vue?vue&type=style&index=0&id=703ffdd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703ffdd8",
  null
  
)

export default component.exports